
export default function Toolbar({ hasAnyLeaf, onSave, saving, saveMsg }) {
  if (!hasAnyLeaf) return null;
  return (
    <div style={{ marginBottom: 12, display: "flex", gap: 8, alignItems: "center" }}>

      <button className="btn btn-success" onClick={onSave} disabled={saving}>
        {saving ? "Salvataggio..." : "Salva gerarchia"}
      </button>

      {saveMsg && <span style={{ fontSize: 13 }}>{saveMsg}</span>}
    </div>
  );
}
